module.exports = require("@ember/component/helper");